<div class="nav-list-container">

  <!-- <mat-nav-list dense> -->
  <mat-nav-list>
    <!-- <a mat-list-item routerLink="/sales-contract/sales-contracts" *ngIf="this.usersService.userPermissions.action.menu.manageSalesContracts">Sales Contracts</a>  -->
    <a mat-list-item>Configuration</a>
    @if (this.showTimeProvider()) {
      <a class="sub-menu" mat-list-item (click)="setTimeProvider()" >Current time <BR/> ({{currentDatetimeValue() | date: "dd-MMM-yyyy HH:mm"}}) </a>
    }
  </mat-nav-list>
</div>
